/* CartIconComponent template */
import { FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { CartIconComponent } from './cwc-cart-icon';

/**
 * Definition of  parameters that the template needs to work.
 */
interface CartIconTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: CartIconComponent;
  version: string;

  // Specify parameters that are required to be passed down to the template here.
}

const MIN_ITEM_COUNT = 9;

const CartIconTemplate: FunctionalComponent<CartIconTemplateProps> = ({ controller, version }) => (
  <Host>
    <a href={controller.cartLink}>
      <div class="wrap" data-version={version}>
        <slot name={'svg'} />
        <div
          class={
            'bubble ' +
            (controller.itemsCount <= 0 ? 'hide ' : '') +
            (controller.itemsCount > MIN_ITEM_COUNT ? 'extended-width' : '')
          }
          aria-live={'polite'}
        >
          <svg
            viewBox={controller.itemsCount <= MIN_ITEM_COUNT ? '0 0 20 20' : '0 0 30 20'}
            class={'count-svg'}
            role={'status'}
          >
            <text class="count" x="52%" y="57%" dominant-baseline="middle" text-anchor="middle">
              {controller.itemsCount > MIN_ITEM_COUNT ? '9+' : controller.itemsCount}
            </text>
          </svg>
        </div>
      </div>
    </a>
  </Host>
);

export default CartIconTemplate;
